<!-- 佣金记录 -->
<template>
  <div id="commission-page">
    <!-- header start -->
    <!-- <van-nav-bar
      title=""
      left-arrow
      :border="false"
      @click-left="goBack"
      :safe-area-inset-top="true"
      fixed
      :placeholder="true"
      :z-index="99"
    /> -->
    <div class="navbar">
      <div class="left" @click="onback">
        <img src="@/assets/images/back.png" />
      </div>
      <!-- <div class="center">净水器</div>
      <div class="right"><img @click="onRefresh" :src="refreshIcon" /></div> -->
    </div>
    <div class="commission-area-box">
      <img src="~@/assets/images/top-bg-2.png" alt="" class="bg" />
      <div class="profit-box">
        <div class="bd">
          <div class="check-date" @click="commissionDateShow = true">
            <!-- <div class="month">12月</div>
            <div class="year">2021年</div> 
            <van-icon name="arrow-down" size="12" color="#999" />-->
          </div>

          <div class="profit-total">
            <div class="profit-total-tit">累计总收益(元)</div>
            <div class="profit-total-price">{{ totalPrice }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- header end -->

    <!-- 导航 start -->
    <van-sticky offset-top="0px">
      <div class="menu-box">
        <div class="every-menu" @click="menuClick(-1)" tapmode>
          <span :class="selectId == -1 ? 'menu-click' : ''">全部</span>
        </div>
        <div class="every-menu" @click="menuClick(0)">
          <span :class="selectId == 0 ? 'menu-click' : ''">待返</span>
        </div>
        <div class="every-menu" @click="menuClick(1)">
          <span :class="selectId == 1 ? 'menu-click' : ''">已返</span>
        </div>
        <div class="every-menu" @click="menuClick(2)">
          <span :class="selectId == 2 ? 'menu-click' : ''">失效</span>
        </div>
        <van-popover
          v-model="showPopover"
          trigger="click"
          :actions="actions"
          @select="onSelect"
          placement="bottom-end"
        >
          <template #reference>
            <van-icon
              name="arrow-down"
              color="#24a378"
              size="15"
              class="select-btn"
            />
          </template>
        </van-popover>
      </div>
    </van-sticky>
    <!-- 导航 end -->
    <!-- 标题栏 start -->
    <div class="line-title">
      <span class="line"></span>
      <div class="title">{{ selectPopover }}</div>
      <span class="line"></span>
    </div>
    <!-- 标题栏 end -->

    <div v-for="(item, i) in tabs" :key="i" v-if="selectId == item">
      <CommissionItem :level="type" :status="selectId"></CommissionItem>
    </div>

    <!-- 佣金item start -->
    <!-- <div
      class="commission-item"
      
      v-for="(item, i) in [1, 2]"
      :key="i"
      @click="goCommissionPage()"
    >
      <div class="thead van-hairline--bottom">
        <div class="thead-left">
          <img
            src="https://img.yzcdn.cn/public_files/2017/10/24/e5a5a02309a41f9f5def56684808d9ae.jpeg"
            alt=""
            class="avatar"
          />
          <div class="name">科比.布莱恩特</div>
        </div>
        <div class="thead-right">
          会员级员：<span class="grade">直推代理</span>
        </div>
      </div>
      <div class="tbody">
        <div class="th">
          <img
            src="https://img.yzcdn.cn/public_files/2017/10/24/e5a5a02309a41f9f5def56684808d9ae.jpeg"
            alt=""
            class="thumb"
          />
        </div>
        <div class="bd">
          <div class="one-line">
            <div class="goods-name">海南产生鲜百香果500G</div>
            <div class="price">￥699</div>
          </div>
          <div class="two-line">
            <div class="date">下单时间:2021-12-08 12:30</div>
            <div class="num">X1</div>
          </div>
          <div class="three-line">
            <div class="commission">
              佣金:<span class="hlight">￥300元</span>
            </div>
            <div class="show-btn">查看详情</div>
          </div>
        </div>
      </div>


    </div> -->
    <!-- 佣金item start -->

    <!-- 日期 popup start -->
    <van-popup v-model="commissionDateShow" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="commissionDateShow = false"
        @cancel="commissionDateShow = false"
        @change="commissionDateChange"
      />
    </van-popup>
    <!-- 日期 popup end -->
  </div>
</template>

<script>
import common from "../../../tools/common";
import CommissionItem from "../../../components/CommissionItem.vue";

import { DatetimePicker } from "vant";
import { Popover } from "vant";
import { Sticky } from "vant";
export default {
  data() {
    return {
      type: 0,
      selectId: -1,
      minDate: new Date(2019, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      commissionDateShow: false,
      tabs: [-1, 0, 1, 2],
      tabFills: [],
      showPopover: false,
      selectPopover: "全部",
      // 通过 actions 属性来定义菜单选项
      // actions: [
      //   { text: "全部", id: 0 },
      //   { text: "普通会员", id: 1 },
      //   { text: "直属代理", id: 2 },
      //   { text: "团队代理", id: -1 },
      //   { text: "老板", id: 3 }
      // ],
      actions: [
        { text: "全部", id: 0 },
        { text: "普通会员", id: 1 },
        { text: "直属代理", id: 2 },
        { text: "团队代理", id: -1 },
        { text: "老板", id: 3 }
      ],
      totalPrice: 0,
    };
  },
  components: {
    [DatetimePicker.name]: DatetimePicker,
    [Popover.name]: Popover,
    [Sticky.name]: Sticky,
    CommissionItem,
  },
  methods: {
    init() {
      var that = this;
      this.$store
        .dispatch({
          type: "GetSumCommission",
        })
        .then((res) => {
          common.Response.callNotMsgResponse(res, function(result) {
            that.totalPrice = result;
          });
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    goCommissionPage() {
      this.$router.push("/commissionDetails");
    },

    commissionDateChange(picker, value, index) {
      let dateArray = picker.getValues();
      this.commissionDate = dateArray.join("-");
      console.log(value + index);
    },

    menuClick(tab_con) {
      this.selectId = tab_con; // 选中tab内容块展示
      // var findData = this.tabFills.filter(x => x == this.type);
      // if (findData.length == 0) {
      //   this.tabFills.push(this.type);
      // }
    },
    onback() {
      this.$router.go(-1);
    },
    onSelect(action, selectIndex) {
      var that = this;
      console.log(action["text"]);
      this.selectPopover = action["text"];

      this.actions.forEach(function(item, index) {
        if (index == selectIndex) {
          item.className = "commissionActive";
          console.log(item);
          that.type = item.id;
        } else {
          item.className = "";
        }
      });
      //action.className = 'commissionActive'
    },
  },
  created() {
    this.init();
  },
};
</script>
<style lang="less" scoped>
.navbar {
  position: absolute;
  display: flex;
  flex-direction: row;
  height: 40px;
  color: white;
  width: 100%;
  // background-color: #037cff;
  z-index: 999;
  .left {
    flex: 1;
    display: flex;
    align-items: center;
    padding-left: 5px;
    img {
      width: 20px;
      height: 20px;
    }
  }
  .center {
    flex: 3;
    text-align: center;
    align-self: center;
    font-size: 16px;
  }
  .right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding-right: 10px;
    img {
      width: 20px;
      height: 20px;
    }
  }
}
.commission-area-box {
  width: 100%;
  height: auto;
  padding-bottom: 10.5px;
  position: relative;
}

.commission-area-box > .bg {
  width: 100%;
  display: block;
  position: absolute;
  top: 0;
  background-size: 100% 100%;
  height: 140px;
}
.profit-box {
  background: url("~@/assets/images/cash-bag.png") #fff right 25px center
    no-repeat;
  background-size: 42px 48px;
  padding: 12px 18px;
  margin: 0 10px;
  border-radius: 6px;
  z-index: 1;
  position: relative;
  margin-bottom: 63px;
  top: 40px;
  .bd {
    .check-date {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      .month {
        font-size: 15px;
        color: #1d1d1d;
      }
      .year {
        margin-left: 14px;
        font-size: 12px;
        color: #7d7d7d;
      }
    }
    .profit-total {
      display: flex;
      align-items: center;
      .profit-total-tit {
        font-size: 12px;
        color: #737373;
        margin-right: 8px;
      }
      .profit-total-price {
        font-size: 21px;
        color: #1d1d1d;
      }
    }
  }
}
.menu-box {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  background: #f5f5f5;
}
.every-menu {
  flex: 1;
  overflow: hidden;
  text-align: center;
}
.every-menu span {
  height: 42px;
  line-height: 42px;
  font-size: 14px;
  color: #222;
  position: relative;
  display: inline-flex;
}
.every-menu span::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  border-radius: 999px;
  background: transparent;
}
.every-menu span.menu-click {
  color: #24a378;
}
.every-menu span.menu-click::after {
  background: #24a378;
}

.select-btn {
  padding: 10px 15px;
}
//佣金item
.commission-item {
  margin: 10px;
  background: #fff;
  padding: 0 14px;
  border-radius: 6px;
  overflow: hidden;
  box-sizing: border-box;
  .thead {
    display: flex;
    align-items: center;
    padding: 10px 0;
    .thead-left {
      flex: 1;
      overflow: hidden;
      display: flex;
      align-items: center;
      .avatar {
        width: 26px;
        height: 26px;
        border-radius: 50%;
        object-fit: cover;
        margin-right: 8px;
      }
      .name {
        font-size: 13px;
        color: #3d3c3c;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    .thead-right {
      margin-left: 15px;
      flex: 1;
      overflow: hidden;
      text-align: right;
      font-size: 12px;
      color: #ababab;
      .grade {
        color: #3d3c3c;
      }
    }
  }
  .tbody {
    display: flex;
    align-items: center;
    padding: 12px 0 15px;
    .th {
      margin-right: 15px;
      .thumb {
        width: 58px;
        height: 58px;
        object-fit: cover;
        border-radius: 4px;
      }
    }
    .bd {
      flex: 1;
      overflow: hidden;
      .one-line {
        display: flex;
        align-items: center;
        overflow: hidden;
        margin-bottom: 6px;
        .goods-name {
          flex: 1;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 14px;
          color: #000000;
        }
        .price {
          margin-left: 15px;
          font-size: 14px;
          color: #000000;
          font-family: Arial, Helvetica, sans-serif;
        }
      }
      .two-line {
        display: flex;
        align-items: center;
        overflow: hidden;
        .date {
          flex: 1;
          overflow: hidden;
          font-size: 12px;
          color: #b7b7b7;
        }
        .num {
          font-size: 10px;
          color: #b7b7b7;
          margin-left: 15px;
        }
      }
      .three-line {
        margin-top: 3px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .commission {
          font-size: 10px;
          color: #000;
          .hlight {
            color: #24a378;
            font-size: 13px;
          }
        }
        .show-btn {
          margin-left: 15px;
          line-height: 1;
          font-size: 12px;
          padding: 4px 8px;
          border: 1px solid;
          color: #464646;
          border-radius: 999px;
        }
      }
    }
  }
}
.line-title {
  display: flex;
  align-items: center;
  margin: 12px 10px;
  .line {
    height: 1px;
    flex: 1;
    overflow: hidden;
    width: 100%;
    background: #b9b9b9;
  }
  .title {
    font-size: 15px;
    color: #232323;
    padding: 0 12px;
  }
}
//老板
.laoban-item {
  margin: 10px;
  background: #fff;
  padding: 18px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  .th {
    margin-right: 12px;
    .avatar {
      width: 52px;
      height: 52px;
      object-fit: cover;
      border-radius: 50%;
    }
  }
  .bd {
    flex: 1;
    overflow: hidden;
    .name {
      font-size: 14px;
      color: #000;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .yeji {
      margin-top: 6px;
      font-size: 12px;
      color: #8e8e8e;
      .num {
        color: #000;
      }
    }
  }
  .ft {
    margin-left: 15px;
    text-align: right;
    .tuandui {
      font-size: 12px;
      color: #8e8e8e;
      .num {
        color: #3c3c3c;
      }
    }
    .jiang {
      font-size: 12px;
      color: #8e8e8e;
      margin-top: 4px;
      .num {
        color: #24a378;
        font-size: 13px;
      }
    }
  }
}
/** popover***/
</style>
<style lang="less">
#commission-page {
  .van-nav-bar {
    background-image: url("~@/assets/images/top-bg-1.png");
    background-size: 100% 100%;
  }
  .van-nav-bar .van-icon {
    color: #fff;
    font-size: 20px;
  }
  .van-nav-bar__title {
    color: #fff;
  }
}
.van-popover__action.commissionActive {
  color: #24a378;
}
</style>
